module.exports = __webpack_public_path__ + "static/img/strona_013.3af5c1b8.jpg";